import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthSession, signIn } from '../lib/auth';

export function Login() {
  const { user, loading } = useAuthSession();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="full-page-loader">…</div>;
  if (user) return <Navigate to="/" replace />;

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    const result = await signIn(email, password);
    setSubmitting(false);
    if (!result.ok) {
      setError(result.error);
      return;
    }
    // Force a reload so useAuthSession re-hydrates from the freshly-stored token.
    window.location.href = '/';
  }

  return (
    <main className="login">
      <div className="login__card">
        <header className="login__head">
          <div className="login__rule">
            <span>Vol. 01 · Ed. 001</span>
            <span>Sign in</span>
          </div>
          <h1 className="login__title">
            The Stax <em>Reply</em> Console
          </h1>
          <p className="login__deck">
            Sign in with your team email. No public sign-ups — accounts are issued by Luca.
          </p>
        </header>

        <form className="login__form" onSubmit={handleSubmit}>
          <label className="login__field">
            <span>Email</span>
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label className="login__field">
            <span>Password</span>
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          {error && <div className="login__error">{error}</div>}
          <button type="submit" className="login__submit" disabled={submitting}>
            {submitting ? 'signing in…' : 'enter'}
          </button>
        </form>

        <footer className="login__foot">
          <span>Forgot password? Ask Luca to issue a reset link.</span>
        </footer>
      </div>
    </main>
  );
}
